import React, { forwardRef, useEffect, useImperativeHandle, useState, } from 'react';
import { BASE_ICON_SPRITE_PATH } from '../icon/icon-constants';
import { Form } from './form';
import { FormSeperator } from './form-seperator';
import { InputFactory } from './input-factory';
import { isValidField } from './utils';
export const FormBuilderComponent = ({ formFields, viewMode = 'edit', itemLayout = 'vertical', isEdited }, ref) => {
    /** Storing initial form state. Also used to store the form fields
     *  on onChange event for each form fields
     */
    const [formState, setFormState] = useState(formFields);
    useEffect(() => {
        setFormState(formFields);
    }, [formFields]);
    const handleOnSubmit = () => {
        const updateState = formState.map((formField) => {
            const tempFormField = Object.assign(formField);
            const value = formField.config.type === 'file'
                ? formField.file
                : formField.value;
            const isValid = isValidField(formField.id, value, formField.validation);
            tempFormField.valid = isValid;
            return tempFormField;
        });
        setFormState(updateState);
        return updateState;
    };
    useImperativeHandle(ref, () => ({
        onSubmitForm: () => {
            return formState;
        },
        onCancelForm: () => {
            return formState;
        },
        validateAndSubmitForm: () => {
            return handleOnSubmit();
        },
    }));
    /** Callback method to handle all the formfield value changed
     *  store it locally to be send back on submit button click
     */
    const onValueChanged = (id, value) => {
        const updateState = formState.map((formField) => {
            const tempFormField = Object.assign(formField);
            if (id === formField.id) {
                const isValid = isValidField(id, value, formField.validation);
                tempFormField.valid = isValid;
                if (formField.config.type === 'file') {
                    tempFormField.file = value;
                }
                else {
                    tempFormField.value = value;
                }
            }
            return tempFormField;
        });
        if (isEdited) {
            isEdited(true, id);
        }
        setFormState(updateState);
    };
    return (React.createElement(Form, { "data-radiant-v2": true },
        React.createElement("link", { rel: "preload", href: BASE_ICON_SPRITE_PATH, as: "image" }), /** Loops through the form and generate form fields from config objects */
        formFields.map((formItem) => {
            return (React.createElement("div", { key: formItem.id },
                React.createElement(InputFactory, { rowLayout: itemLayout, mode: viewMode, ...formItem, onValueChanged: onValueChanged }),
                viewMode === 'view' ? React.createElement(FormSeperator, null) : null));
        })));
};
const FormBuilder = forwardRef(FormBuilderComponent);
export { FormBuilder };
//# sourceMappingURL=form-builder.js.map